// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".titulo[data-v-0abb4c6c]{color:#3d3f40;font-family:Trebuchet MS;font-size:20px}.container-treinamentos[data-v-0abb4c6c]{display:flex;flex-direction:row;flex-wrap:wrap;gap:20px;margin-top:16px;width:100%}.pagination-connection[data-v-0abb4c6c]{margin-top:24px}.resultado-busca[data-v-0abb4c6c]{color:#7a7e83;font-size:18px}.termo-busca[data-v-0abb4c6c]{font-weight:700}", ""]);
// Exports
module.exports = exports;
